// src/blocks/title/title.tsx
import { jsx } from "react/jsx-runtime";
var Title = ({ className, id, level = "h2", text }) => {
  if (!text) return null;
  const Tag = level;
  return /* @__PURE__ */ jsx(Tag, { className, id, children: text && /* @__PURE__ */ jsx("span", { children: text }) });
};
var title_default = Title;

export {
  title_default
};
